import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import DiagramConfiguration from '@/projects/entities/diagram-configuration'
import moment from 'moment'

@Component
export default class TimelineDiagramConfiguration extends Vue {

    public configuration: DiagramConfiguration = new DiagramConfiguration()
    public dialog = false
    public editMode = false
    public dates: string[] = []
    public rangeMode: boolean = true
    public menu = false

    public edit(configuration: DiagramConfiguration) {
        this.configuration = configuration
        this.dialog = true
        this.editMode = true

        if (this.configuration.timelineConfig.dateRange.length > 0) {
            this.dates[0] = this.configuration.timelineConfig.dateRange[0].date
            this.dates[1] = this.configuration.timelineConfig.dateRange[1].date
        }

        if (this.configuration.timelineConfig.rangeMode === 'true') {
            this.rangeMode = true
        } else {
            this.rangeMode = false
        }
    }

    public close() {
        this.dialog = false
    }

    private addEntry() {
        this.configuration.timelineConfig.phaseNames.push({
            number: '' + (this.configuration.timelineConfig.phaseNames.length + 1),
            name: '',
        })
    }

    private removeEntry(entry: any) {
        this.$delete(
            this.configuration.timelineConfig.phaseNames,
            this.configuration.timelineConfig.phaseNames.indexOf(entry))
    }

    private resetDateRange() {
        this.rangeMode = !this.rangeMode
    }

    private async save() {
        if (this.rangeMode) {
            if (moment(this.dates[1]) < moment(this.dates[0])) {
                const tmp = this.dates[0]
                this.dates[0] = this.dates[1]
                this.dates[1] = tmp
            }
            this.configuration.timelineConfig.dateRange[0] = {
                label: 'From',
                date: this.dates[0],
            }
            this.configuration.timelineConfig.dateRange[1] = {
                label: 'To',
                date: this.dates[1],
            }
        }
        this.configuration.timelineConfig.rangeMode = String(this.rangeMode)
        this.$emit('update', this.configuration)
    }
}
